export const LOOKUP_FEATURE_STATE_KEY = 'lookup';
